import { ErrorCircle as R } from "@styled-icons/boxicons-regular";
import { getBackgroundColorStyle as v, getBackgroundImageStyle as k } from "@typedream/core";
import x from "classnames";
import N from "react";
import { useForm as T, FormProvider as V } from "react-hook-form";
import { getHeightStyle as B, getWidthStyle as f } from "../utils/sizing.js";
import { formElement as E, successIcon as j, successButton as D, successButtonIcon as H, alignLeft as J, alignCenter as P, alignRight as Y, alignTop as Z, alignMiddle as z, alignBottom as I, errorContainer as $, errorMessageHeader as q, errorMessagePrefix as G } from "./FormElement.css.js";
import { generateFormInitialValue as K } from "./FormElement.utils.js";
import { jsxs as a, jsx as i } from "react/jsx-runtime";
const Q = (t) => {
  var l, m, e, g, h, d, s, o;
  return typeof ((m = (l = t == null ? void 0 : t.response) == null ? void 0 : l.data) == null ? void 0 : m.msg) == "string" ? (g = (e = t == null ? void 0 : t.response) == null ? void 0 : e.data) == null ? void 0 : g.msg : typeof ((h = t == null ? void 0 : t.error) == null ? void 0 : h.message) == "string" ? (d = t == null ? void 0 : t.error) == null ? void 0 : d.message : typeof (t == null ? void 0 : t.message) == "string" ? t == null ? void 0 : t.message : JSON.stringify((o = (s = t == null ? void 0 : t.response) == null ? void 0 : s.data) == null ? void 0 : o.msg) || (t == null ? void 0 : t.toString()) || JSON.stringify(t) || t || "Something went wrong";
};
function C3({
  element: t,
  className: l,
  attributes: m,
  backgroundImage: e,
  handleFormSubmission: g,
  children: h
}) {
  var b;
  const {
    form_id: d,
    width: s,
    height: o,
    align: u,
    vertical_align: p,
    width_max: c,
    background: M,
    backgroundDarken: w,
    mobile_hide: S,
    desktop_hide: y,
    redirect_url: r,
    customAttributes: n
  } = t, C = T({
    defaultValues: K(t.children)
  }), [_, F] = N.useState("");
  if (N.useEffect(() => {
    C.formState.isSubmitSuccessful && r && window.open(r, "_self");
  }, [r, C.formState.isSubmitSuccessful]), C.formState.isSubmitSuccessful && !r)
    return /* @__PURE__ */ a("div", {
      className: x(l, E, {
        "mobile:hidden": S,
        "desktop:hidden": y
      }),
      style: {
        "--min-height": B(o != null ? o : 377).height,
        "--width": f(s, c).width,
        "--max-width": f(s, c).maxWidth,
        ...v("default"),
        ...typeof e == "string" && k(e, w),
        borderRadius: 24
      },
      children: [/* @__PURE__ */ i("svg", {
        className: j,
        width: "46",
        height: "46",
        viewBox: "0 0 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ i("path", {
          d: "M42.0789 17.5838L42.0789 17.5837L42.0725 17.5771C41.7147 17.21 41.3781 16.8594 41.0978 16.5257C40.8097 16.1825 40.6324 15.9162 40.5504 15.7248C40.4761 15.5515 40.4199 15.2768 40.3895 14.8601C40.3662 14.5398 40.3611 14.2007 40.3554 13.8207C40.3538 13.7104 40.3521 13.5967 40.3499 13.479C40.3499 13.4776 40.3498 13.4762 40.3498 13.4749L40.3491 13.3997C40.3317 11.6658 40.3068 9.19263 38.5571 7.44289C36.8074 5.69315 34.3342 5.66831 32.6003 5.6509C32.5736 5.65063 32.5472 5.65037 32.5208 5.6501C32.018 5.64061 31.5512 5.63143 31.1353 5.59713C30.7053 5.56167 30.4167 5.5049 30.2478 5.43834C30.0978 5.37927 29.8449 5.21633 29.4893 4.91699C29.1505 4.63179 28.7903 4.28553 28.4229 3.92752L28.4229 3.92749L28.4162 3.92111C28.389 3.89502 28.3614 3.86865 28.3336 3.84203C27.11 2.67045 25.3654 1 23 1C20.6346 1 18.89 2.67045 17.6664 3.84203C17.6386 3.86865 17.611 3.89502 17.5838 3.92111L17.5837 3.92108L17.5771 3.92752C17.21 4.28527 16.8594 4.62194 16.5257 4.90217C16.1825 5.19032 15.9162 5.36761 15.7248 5.4496C15.5515 5.5239 15.2768 5.58008 14.8601 5.61046C14.5398 5.63382 14.2007 5.63888 13.8207 5.64455C13.7105 5.64619 13.5968 5.64789 13.4792 5.6501C13.4529 5.65037 13.4264 5.65063 13.3997 5.6509C11.6658 5.66831 9.19263 5.69315 7.44289 7.44289C5.69315 9.19263 5.66831 11.6658 5.6509 13.3997C5.65063 13.4264 5.65037 13.4528 5.6501 13.4792C5.64061 13.982 5.63143 14.4488 5.59713 14.8647C5.56167 15.2947 5.5049 15.5833 5.43834 15.7522C5.37927 15.9022 5.21633 16.1551 4.91699 16.5107C4.63179 16.8495 4.28553 17.2097 3.92752 17.5771L3.92749 17.5771L3.92111 17.5838C3.89502 17.611 3.86865 17.6386 3.84203 17.6664C2.67045 18.89 1 20.6346 1 23C1 25.3654 2.67045 27.11 3.84203 28.3336C3.86865 28.3614 3.89502 28.389 3.92111 28.4162L3.92108 28.4163L3.92752 28.4229C4.28527 28.79 4.62194 29.1406 4.90217 29.4743C5.19032 29.8175 5.36761 30.0838 5.4496 30.2752C5.5239 30.4485 5.58008 30.7232 5.61046 31.1399C5.63382 31.4602 5.63888 31.7993 5.64455 32.1793C5.64619 32.2895 5.64789 32.4032 5.6501 32.5208C5.65037 32.5471 5.65063 32.5736 5.6509 32.6003C5.66831 34.3342 5.69315 36.8074 7.44289 38.5571C9.19263 40.3068 11.6658 40.3317 13.3997 40.3491L13.4749 40.3498C13.4762 40.3498 13.4776 40.3499 13.4789 40.3499C13.9819 40.3594 14.4487 40.3686 14.8647 40.4029C15.2947 40.4383 15.5833 40.4951 15.7522 40.5617C15.9022 40.6207 16.1551 40.7837 16.5107 41.083C16.8495 41.3682 17.2097 41.7145 17.5771 42.0725L17.5771 42.0725L17.5838 42.0789C17.6111 42.105 17.6386 42.1314 17.6664 42.158C18.89 43.3296 20.6346 45 23 45C25.3654 45 27.11 43.3296 28.3336 42.158C28.3614 42.1314 28.3889 42.105 28.4162 42.0789L28.4163 42.0789L28.4229 42.0725C28.79 41.7147 29.1406 41.3781 29.4743 41.0978C29.8175 40.8097 30.0838 40.6324 30.2752 40.5504C30.4485 40.4761 30.7232 40.4199 31.1399 40.3895C31.4602 40.3662 31.7993 40.3611 32.1793 40.3554C32.2896 40.3538 32.4033 40.3521 32.521 40.3499C32.5224 40.3499 32.5238 40.3498 32.5251 40.3498L32.6003 40.3491C34.3342 40.3317 36.8074 40.3068 38.5571 38.5571C40.3068 36.8074 40.3317 34.3342 40.3491 32.6003L40.3498 32.5251C40.3498 32.5238 40.3499 32.5224 40.3499 32.5211C40.3594 32.0181 40.3686 31.5513 40.4029 31.1353C40.4383 30.7053 40.4951 30.4167 40.5617 30.2478C40.6207 30.0978 40.7837 29.8449 41.083 29.4893C41.3682 29.1505 41.7145 28.7903 42.0725 28.4229L42.0725 28.4229L42.0789 28.4162C42.105 28.3889 42.1314 28.3614 42.158 28.3336C43.3296 27.11 45 25.3654 45 23C45 20.6346 43.3296 18.89 42.158 17.6664C42.1314 17.6386 42.105 17.6111 42.0789 17.5838ZM20.2499 29.5V29.5L20.24 29.5C20.1151 29.5005 19.995 29.4524 19.9049 29.366L19.9034 29.3645L14.4096 24.1145L14.3932 24.0989L14.3762 24.084C14.3254 24.0397 14.2841 23.9855 14.2547 23.9248C14.2254 23.8642 14.2086 23.7982 14.2054 23.7308C14.2022 23.6635 14.2127 23.5962 14.2362 23.533C14.2597 23.4699 14.2957 23.4121 14.3421 23.3632C14.3884 23.3143 14.4442 23.2752 14.5061 23.2484C14.5679 23.2216 14.6346 23.2076 14.702 23.2072C14.7694 23.2068 14.8362 23.2201 14.8983 23.2461C14.9605 23.2722 15.0167 23.3106 15.0637 23.359L15.0771 23.3728L15.0911 23.3861L19.5536 27.6424L20.2435 28.3004L20.9336 27.6427L30.8885 18.1556C30.9839 18.0776 31.105 18.0375 31.2285 18.0433C31.3574 18.0494 31.4789 18.1051 31.5677 18.1987C31.6565 18.2924 31.7056 18.4167 31.7049 18.5457C31.7041 18.6701 31.6571 18.7896 31.5731 18.881L20.6065 29.3611C20.5097 29.4511 20.3822 29.5008 20.2499 29.5Z",
          fill: "#12B76A",
          stroke: "white",
          strokeWidth: "2"
        })
      }), /* @__PURE__ */ i("h2", {
        children: "Thank You"
      }), /* @__PURE__ */ i("p", {
        children: "Your submission has been submitted"
      }), /* @__PURE__ */ a("button", {
        type: "button",
        onClick: () => {
          window.open(`https://typedream.com/forms?utm_source=form-thank-you-page:${d}`, "_blank");
        },
        className: D,
        children: [/* @__PURE__ */ i("img", {
          src: "/logo-gradient.svg",
          alt: "logo",
          className: H
        }), "Create your own form!"]
      })]
    });
  const W = async (L) => {
    try {
      await g(d, L);
    } catch (O) {
      F(Q(O));
    }
  };
  return /* @__PURE__ */ i(V, {
    ...C,
    children: /* @__PURE__ */ a("form", {
      ...n,
      id: (b = n == null ? void 0 : n.id) != null ? b : t.id,
      className: x(l, E, {
        "mobile:hidden": S,
        "desktop:hidden": y,
        [J]: u === "align_left",
        [P]: u === "align_center",
        [Y]: u === "align_right",
        [Z]: p === "align_start",
        [z]: p === "align_center",
        [I]: p === "align_end"
      }, n == null ? void 0 : n.className),
      style: {
        "--min-height": B(o).height,
        "--width": f(s, c).width,
        "--max-width": f(s, c).maxWidth,
        ...v(M),
        ...typeof e == "string" && k(e, w)
      },
      onSubmit: C.formState.isSubmitting ? (L) => L.preventDefault() : C.handleSubmit(W),
      ...m,
      children: [h, _ && /* @__PURE__ */ a("div", {
        className: $,
        children: [/* @__PURE__ */ i(R, {
          size: 24
        }), /* @__PURE__ */ a("div", {
          children: [/* @__PURE__ */ i("div", {
            className: q,
            children: /* @__PURE__ */ i("b", {
              children: "Oops, we are having server issues"
            })
          }), /* @__PURE__ */ a("div", {
            children: [/* @__PURE__ */ i("p", {
              className: G,
              children: "Error Message:"
            }), _]
          })]
        })]
      })]
    })
  });
}
export {
  C3 as FormElement,
  Q as errToString
};
